import {
  Button,
  Dialog,
  DialogActions,
  DialogBody,
  DialogContent,
  DialogSurface,
  DialogTitle,
  DialogTrigger,
} from "@fluentui/react-components";
import { WarningIcon } from "@fluentui/react-icons-mdl2";
import { RemoveButton } from "components/styled";
import { useAppTheme } from "hooks/useAppTheme";
import React from "react";
import { CSSProperties } from "styled-components";

type Props = {
  isOpen: boolean;
  title: string;
  description: string;
  dismissLabel?: string;
  confirmLabel?: string;
  isDisabled?: boolean;
  onConfirm: () => void;
  toggleOpen: () => void;
  content?: React.JSX.Element;
  style?: CSSProperties;
};

export const ConfirmationDialog = ({
  title,
  description,
  isOpen,
  dismissLabel,
  onConfirm,
  confirmLabel,
  isDisabled = false,
  content,
  toggleOpen,
  style = {},
}: Props) => {
  const theme = useAppTheme();
  return (
    <Dialog modalType="alert" open={isOpen}>
      <DialogSurface style={style}>
        <DialogBody>
          <DialogTitle
            style={{
              display: "flex",
              alignItems: "center",
              color: theme.palette.redDark,
              gap: "5px",
            }}
          >
            <WarningIcon />
            {title}
          </DialogTitle>
          <DialogContent>
            {description}
            {content}
          </DialogContent>
          <DialogActions>
            <DialogTrigger disableButtonEnhancement>
              <Button appearance="secondary" onClick={toggleOpen}>
                {dismissLabel || "Close"}
              </Button>
            </DialogTrigger>
            <RemoveButton onClick={onConfirm} disabled={isDisabled}>
              {confirmLabel || "Confirm"}
            </RemoveButton>
          </DialogActions>
        </DialogBody>
      </DialogSurface>
    </Dialog>
  );
};
